define('ordersDetailOrderPhrasesView',[
  'module',
  'backbone',
  'marionette',
  'underscore',
  'jquery',
  'app',
  'settings',
  'windows',
  'ordersDetailOrderPhrasesItemView',
  'ordersDetailOrderPhrasesPickerView',
  'template!ordersDetailOrderPhrasesView',
  'entities/phrases'
], function (
  Module,
  Backbone,
  Marionette,
  _,
  $,
  App,
  Settings,
  Windows,
  PhraseItemView,
  PhrasePickerView,
  Tpl
) {
  'use strict';

  var PhrasesListView = Marionette.CollectionView.extend({
    tagName: 'div',
    className: 'phrases-list',
    childView: PhraseItemView,

    childEvents: {
      'remove:phrase': 'onRemovePhrase'
    },

    onRemovePhrase: function (childView, model) {
      this.trigger('remove:phrase', model);
    }
  });

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'order-phrases-view',

    ui: {
      counter: '.counter',
      addButton: '.add'
    },

    regions: {
      listRegion: '.list-region'
    },

    events: {
      'click @ui.addButton': 'onAdd'
    },

    onShow: function () {
      this.collection = new Backbone.Collection();

      this.listView = new PhrasesListView({
        collection: this.collection
      });
      this.listView.on('remove:phrase', this.onRemovePhrase, this);
      this.getRegion('listRegion').show(this.listView);

      this.fetchPhrases();
    },

    fetchPhrases: function () {
      this.model.getPhrases().done(_.bind(function (phrases) {
        this.collection.reset(phrases);
        this.renderCounter();
      }, this));
    },

    renderCounter: function () {
      if (this.isDestroyed) return;
      this.ui.counter.html(this.collection.length);
    },

    onAdd: function () {
      var self = this;
      var existingSecIds = this.collection.map(function (m) {
        return m.get('secId');
      });

      $.ajax({
        type: 'GET',
        url: App.request('phrases:get-url') + '&first=0&pageSize=1000',
        success: function (phrases) {
          var available = _.filter(phrases, function (p) {
            return !_.contains(existingSecIds, p.secId);
          });

          self._showPhrasePickerPopup(available);
        }
      });
    },

    _showPhrasePickerPopup: function (available) {
      var self = this;

      var pickerView = new PhrasePickerView({
        phrases: available,
        windows: Windows
      });

      pickerView.on('phrases:selected', function (secIds) {
        if (secIds.length === 0) return;

        // Chain requests sequentially to avoid concurrency conflicts
        var chain = $.Deferred().resolve();
        _.each(secIds, function (secId) {
          chain = chain.then(function () {
            return self.model.addPhrase(secId);
          });
        });
        chain.always(function () {
          self.fetchPhrases();
        });
      });

      Windows.open({
        view: function () {
          return pickerView;
        },
        modal: true,
        width: 550,
        maxWidth: 700,
        title: _.i18n('phrases.addToOrder')
      });
    },

    onRemovePhrase: function (model) {
      var secId = model.get('secId');
      this.model.removePhrase(secId).done(_.bind(function () {
        this.collection.remove(model);
        this.renderCounter();
      }, this));
    }
  });
});

